import type { SxProps } from '@mui/material';
import type {
  LineItemFragmentFragment,
  WishlistLineItemsFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Stack, Button, Typography, Dialog, Box, Link, Image } from '@packages/shared';

const EEKContainer: SxProps = {
  position: 'relative',
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: 600,
  my: 2,
  '> img': {
    objectFit: 'contain',
  },
};
export const PowerEfficiency: React.FC<{
  efficiency:
    | LineItemFragmentFragment['product']['powerEfficiencyFlags']
    | WishlistLineItemsFragmentFragment['powerEfficiency']
    | null;
}> = ({ efficiency }) => {
  const [modalOpen, setModalOpen] = useState(false);
  if (efficiency?.length) {
    return (
      <>
        <Stack direction="row" spacing={1} pb={1} flexWrap="wrap">
          {efficiency.map(({ iconText, icon, text }) => (
            <div key={icon}>
              <Button
                onClick={() => setModalOpen(true)}
                sx={{
                  py: 0,
                  px: iconText ? 1 : '0',
                  bgcolor: 'transparent',
                  border: iconText ? '' : 'none',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
                data-testid="eek-button"
                size="small"
                disableRipple={!iconText}
              >
                <Image // here we are distinguishing between the tireLabel since tirelabel has iconText and the other labels do not
                  width={iconText ? '16' : '35'}
                  height={iconText ? '16' : '20'}
                  src={`${icon}.svg`}
                  alt={text ?? iconText ?? ''}
                  unoptimized
                />
                {iconText && (
                  <Typography ml={0.5} variant="body2">
                    {iconText}
                  </Typography>
                )}
              </Button>
            </div>
          ))}
        </Stack>
        <Dialog
          open={modalOpen}
          title={efficiency[0].text ?? efficiency[0].iconText ?? ''}
          handleClose={() => setModalOpen(false)}
          onSubmit={() => setModalOpen(false)}
          dialogContent={
            <Box sx={EEKContainer}>
              <Image
                data-testid="eek-image"
                src={`${efficiency[0].link}?$PDV_portrait_hq$`}
                alt=""
                fill
                unoptimized
              />
            </Box>
          }
        />
        {efficiency[0].dataSheet && (
          <Link
            variant="body3"
            as="a"
            color="text.secondary"
            href={efficiency[0].dataSheet}
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage
              id="LineItem.PowerEfficiency.DataSheet"
              defaultMessage="Produktdatenblatt"
            />
          </Link>
        )}
      </>
    );
  }
  return null;
};
